import React from 'react';
import RefreshIcon from '@mui/icons-material/Refresh';
import SettingsIcon from '@mui/icons-material/SettingsRounded';
import { Divider } from '@mui/material';

import { hasLoadCaseCreationFeatureFlag, hasTrussAnalysisPermission, isLoggedInUserRoot } from '@paragon/login-tools';

import { useAppMonitor } from '../../../../monitor';
import { showSettingsPanel } from '../../../../store/actions/appActions';
import { generateLoadCases } from '../../../../store/actions/paragonProcessActions';
import { selectItem } from '../../../../store/actions/selectActions';
import { getActiveComponentDesign } from '../../../../store/selectors/getActiveComponentDesignSelector';
import { getSelectedItemEntries } from '../../../../store/selectors/getSelectedItemSelector';
import { useAppDispatch, useAppSelector, useIsClientInMobileMode } from '../../../hooks';
import { SceneMenuContent } from '../common/SceneMenuContent';
import { SceneMenuItem } from '../common/SceneMenuItem';
import { AddItemMenuItem } from '../shared-menu-items/AddItemMenuItem';
import { ToggleLockingMenuItem } from '../shared-menu-items/ToggleLockingMenuItem';

export function LoadCasesContainerMenu() {
  const monitor = useAppMonitor();
  const dispatch = useAppDispatch();
  const mobile = useIsClientInMobileMode();

  const isRoot = useAppSelector(isLoggedInUserRoot);
  const componentDesign = useAppSelector(getActiveComponentDesign);
  const selectedItemEntries = useAppSelector(getSelectedItemEntries);

  const hasPermissionForSettings = useAppSelector(hasTrussAnalysisPermission);
  const hasPermissionForLoadCaseCreation = useAppSelector(hasLoadCaseCreationFeatureFlag);

  return (
    <SceneMenuContent>
      <AddItemMenuItem type="loadCase" disabled={!hasPermissionForLoadCaseCreation} />

      {isRoot && (
        <SceneMenuItem
          icon={<RefreshIcon />}
          text="Regenerate Load Cases"
          disabled={componentDesign == null}
          onClick={() => {
            dispatch(generateLoadCases(componentDesign!));
            monitor.recordInteraction('Regenerate Load Cases menu item clicked');
          }}
        />
      )}

      <Divider />

      <ToggleLockingMenuItem type="loadCase" context="container" />

      {hasPermissionForSettings && (
        <SceneMenuItem
          icon={<SettingsIcon />}
          text="Load Settings"
          disabled={componentDesign == null}
          onClick={async () => {
            await dispatch(selectItem(componentDesign, 'componentDesign'));
            dispatch(showSettingsPanel('loadSettings', mobile, selectedItemEntries));

            monitor.recordInteraction('Load Cases => Settings menu item clicked');
          }}
        />
      )}
    </SceneMenuContent>
  );
}
